// helpShots — 사용 안내(/help)에 붙는 설명서 캡처 표(이름 → { src, caption }).
//
// 🔴 명시 import 만 쓴다(require.context 금지) — jest 에서 돌지 않고, webpack 은 import 된
//    파일만 산출물로 내보내므로 이 목록이 곧 "배포되는 캡처"다.
// 🔴 관리자 캡처(d_admin_*)는 여기 두지 않는다. HelpPage 는 게으른 로드가 아니라 바로
//    import 되므로(App.jsx) 여기 넣은 이미지는 로그인 화면에서도 받는 메인 묶음에 들어간다
//    → 관리자 캡처는 utils/adminHelpShots.js(관리자 묶음)에만 둔다.
// 🔴 업무 내용(문의 글·실제 센터명 등)이 보이는 캡처는 그 부분을 가린 판(2026-09-30)을
//    쓴다 — 파일 이름은 그대로이고, 가린 판으로 바꿔 넣은 뒤 여기서 다시 import 한다.

import dHome from '../assets/help/d_home.webp';
import dHelp from '../assets/help/d_help.webp';
import mHome from '../assets/help/m_home.webp';
import mHomeDrawer from '../assets/help/m_home_drawer.webp';
import dChat from '../assets/help/d_chat.webp';
import dChatConv from '../assets/help/d_chat_conv.webp';
import mChat from '../assets/help/m_chat.webp';
import dArchive from '../assets/help/d_archive.webp';
import dProjectPanel from '../assets/help/d_project_panel.webp';
import dWorkspaceOn from '../assets/help/d_workspace_on.webp';
import dInternalDataOn from '../assets/help/d_internal_data_on.webp';
import dChatDocgen from '../assets/help/d_chat_docgen.webp';
import mChatDocgen from '../assets/help/m_chat_docgen.webp';
import dGenerated from '../assets/help/d_generated.webp';
import dDocAutomation from '../assets/help/d_doc_automation.webp';
import dMeetings from '../assets/help/d_meetings.webp';
import dMeetingsDetail from '../assets/help/d_meetings_detail.webp';
import mMeetings from '../assets/help/m_meetings.webp';
import dTalk from '../assets/help/d_talk.webp';
import dDocuments from '../assets/help/d_documents.webp';
import dMessenger from '../assets/help/d_messenger.webp';
import mMessenger from '../assets/help/m_messenger.webp';
import dDrive from '../assets/help/d_drive.webp';
import mDrive from '../assets/help/m_drive.webp';
import dOffice from '../assets/help/d_office.webp';
import dCalendar from '../assets/help/d_calendar.webp';
import dCollabTools from '../assets/help/d_collab_tools.webp';
import dCenterCosts from '../assets/help/d_center_costs.webp';
import dCenterDaily from '../assets/help/d_center_daily.webp';
import dAbcAnalysis from '../assets/help/d_abc_analysis.webp';
import dCenterShippers from '../assets/help/d_center_shippers.webp';
import dDirectory from '../assets/help/d_directory.webp';
import dDxBoard from '../assets/help/d_dx_board.webp';
import dExecMeeting from '../assets/help/d_exec_meeting.webp';
import dSupportBoard from '../assets/help/d_support_board.webp';
import dBoard from '../assets/help/d_board.webp';
import dInquiries from '../assets/help/d_inquiries.webp';
import dInquiriesDetail from '../assets/help/d_inquiries_detail.webp';
import dTickets from '../assets/help/d_tickets.webp';
import mMobileScreenSettings from '../assets/help/m_mobile_screen_settings.webp';
import mMobileNotificationCenter from '../assets/help/m_mobile_notification_center.webp';
import mMobilePushCard from '../assets/help/m_mobile_push_card.webp';
import dMy from '../assets/help/d_my.webp';
import dMySettings from '../assets/help/d_my_settings.webp';
import dContracts from '../assets/help/d_contracts.webp';
import dAuthLogin from '../assets/help/d_auth_login.webp';
import dAuthRegister from '../assets/help/d_auth_register.webp';
import dAuthForgot from '../assets/help/d_auth_forgot.webp';
import mAuthLogin from '../assets/help/m_auth_login.webp';
import mAuthRegister from '../assets/help/m_auth_register.webp';
import mAuthForgot from '../assets/help/m_auth_forgot.webp';

// 이름 = 캡처 파일명(확장자 제외). HelpPage 의 shots·phoneShots 가 이 이름을 쓴다.
export const SHOTS = {
  d_home: { src: dHome, caption: '메인 화면' },
  d_help: { src: dHelp, caption: '사용 안내 화면' },
  m_home: { src: mHome, caption: '모바일 홈 화면(하단 메뉴)' },
  m_home_drawer: { src: mHomeDrawer, caption: '모바일 전체 메뉴' },
  d_chat: { src: dChat, caption: 'AI 채팅 화면' },
  d_chat_conv: { src: dChatConv, caption: 'AI 채팅 대화 화면' },
  m_chat: { src: mChat, caption: '모바일 AI 채팅' },
  d_archive: { src: dArchive, caption: '보관함 화면' },
  d_project_panel: { src: dProjectPanel, caption: '프로젝트를 고른 채팅 화면' },
  d_workspace_on: { src: dWorkspaceOn, caption: '작업공간 파일 패널을 펼친 채팅 화면' },
  d_internal_data_on: { src: dInternalDataOn, caption: '도구 메뉴에서 사내데이터를 켠 채팅 화면' },
  d_chat_docgen: { src: dChatDocgen, caption: '문서 만들기 결과(다운로드 카드)' },
  m_chat_docgen: { src: mChatDocgen, caption: '모바일 문서 만들기 결과' },
  d_generated: { src: dGenerated, caption: '만든 파일 목록' },
  d_doc_automation: { src: dDocAutomation, caption: 'AI 문서 자동화 화면' },
  d_meetings: { src: dMeetings, caption: 'AI 노트 목록' },
  d_meetings_detail: { src: dMeetingsDetail, caption: 'AI 노트 상세(받아쓰기·요약)' },
  m_meetings: { src: mMeetings, caption: '모바일 AI 노트' },
  d_talk: { src: dTalk, caption: '화상회의 화면' },
  d_documents: { src: dDocuments, caption: 'AI 학습자료 등록 화면' },
  d_messenger: { src: dMessenger, caption: '메신저 화면' },
  m_messenger: { src: mMessenger, caption: '모바일 메신저' },
  d_drive: { src: dDrive, caption: '드라이브 화면' },
  m_drive: { src: mDrive, caption: '모바일 드라이브' },
  d_office: { src: dOffice, caption: '오피스 화면' },
  d_calendar: { src: dCalendar, caption: '캘린더 화면' },
  d_collab_tools: { src: dCollabTools, caption: '협업 도구 화면' },
  d_center_costs: { src: dCenterCosts, caption: '센터 비용 통합조회 화면' },
  d_center_daily: { src: dCenterDaily, caption: '센터 일별 실적 화면' },
  d_abc_analysis: { src: dAbcAnalysis, caption: 'ABC분석 화면(분석 실행 전)' },
  d_center_shippers: { src: dCenterShippers, caption: '센터 고객사 명부 화면' },
  d_directory: { src: dDirectory, caption: '조직도 화면(직원 정보 보호를 위해 검색 결과가 없는 상태)' },
  d_dx_board: { src: dDxBoard, caption: 'AX 보드 화면' },
  d_exec_meeting: { src: dExecMeeting, caption: '임원회의 화면' },
  d_support_board: { src: dSupportBoard, caption: '경영지원팀 보드 화면' },
  d_board: { src: dBoard, caption: '사내게시판 화면(일반 탭)' },
  d_inquiries: { src: dInquiries, caption: '문의게시판 목록' },
  d_inquiries_detail: { src: dInquiriesDetail, caption: '문의게시판 상세(답변)' },
  d_tickets: { src: dTickets, caption: 'CS 티켓 화면(고객 정보 보호를 위해 목록이 비어 있는 상태)' },
  m_mobile_screen_settings: { src: mMobileScreenSettings, caption: '모바일 화면 설정(글자 크기·웹 화면 전환)' },
  m_mobile_notification_center: { src: mMobileNotificationCenter, caption: '앱 안 알림함' },
  m_mobile_push_card: { src: mMobilePushCard, caption: '모바일 푸시 알림 설정 카드' },
  d_my: { src: dMy, caption: '내 정보 화면(이번 달 사용량)' },
  d_my_settings: { src: dMySettings, caption: '내 정보의 화면 폰트 · 알림 칸' },
  d_contracts: { src: dContracts, caption: '계약 관리 목록(계약 내용은 가림)' },
  d_auth_login: { src: dAuthLogin, caption: '로그인 화면' },
  d_auth_register: { src: dAuthRegister, caption: '회원가입 화면' },
  d_auth_forgot: { src: dAuthForgot, caption: '비밀번호 재설정 화면' },
  m_auth_login: { src: mAuthLogin, caption: '모바일 로그인' },
  m_auth_register: { src: mAuthRegister, caption: '모바일 회원가입' },
  m_auth_forgot: { src: mAuthForgot, caption: '모바일 비밀번호 재설정' },
};

export default SHOTS;
